import React from 'react';

import { CalculatorPanel } from '../components/CalculatorPanel';
import { HistoryPanel } from '../components/HistoryPanel';
import { useMortalityContext } from '../contexts/MortalityContext';

export function CalculatorPage() {
  const { data, loading, saveCalculation, history, clearHistory } = useMortalityContext();

  return (
    <div className="page-grid">
      <CalculatorPanel data={data} loading={loading} onSave={saveCalculation} />
      <HistoryPanel history={history} onClear={() => { void clearHistory(); }} />
    </div>
  );
}
